import React, { useEffect, useState } from 'react';
import { Switch } from '@headlessui/react';
import { PrimaryBtn, SecondaryBtn } from '../Assets/Buttons';

// RTK Queries
import { useGetEmailNotiStatusQuery, useUnsubscribeEmailMutation, useSubscribeEmailMutation } from '../../services/api/userApi';

const Notifications = () => {
    const { data: emailStatus, isLoading: isEmailStatusLoading, isError: isEmailStatusError } = useGetEmailNotiStatusQuery();
    const [currEmailStatus, setCurrEmailStatus] = useState(false);
    const [emailSubChange, setEmailSubChange] = useState(false);

    const [subscribeEmail, { isLoading: isSubscribing, isError: isSubscribeError, error: subscribeError , isSuccess: isSubscribeSuccess }] = useSubscribeEmailMutation();
    const [unsubscribeEmail, { isLoading: isUnsubscribing, isError: isUnsubscribeError, error: unsubscribeError, isSuccess: isUnsubscribeSuccess }] = useUnsubscribeEmailMutation();

    useEffect(() => {
        if (emailStatus) {
            setCurrEmailStatus(emailStatus?.email_sub || false);
        }
    }, [emailStatus]);

    useEffect(() => {
        if (isEmailStatusLoading) {
            return;
        }

        if (emailStatus?.email_sub !== currEmailStatus) {
            setEmailSubChange(true);
        } else {
            setEmailSubChange(false);
        }
    }, [emailStatus, isEmailStatusLoading, currEmailStatus]);

    const handleCancel = () => {
        setEmailSubChange(false);
        setCurrEmailStatus(emailStatus?.email_sub || false);
    };

    const updateEmailNotifications = async (type) => {
        try {
            // Subscribe user to email notifications
            if (type === "sub") {
                await subscribeEmail();

                if (!isSubscribeSuccess) {
                    setError(subscribeError);
                    setCurrEmailStatus(emailStatus?.email_sub || false);
                }
            // Unsubscribe user to email notifications
            } else {
                await unsubscribeEmail();
                if (!isUnsubscribeSuccess) {
                    setError(unsubscribeError);
                    setCurrEmailStatus(emailStatus?.email_sub || false);
                }
            }
        } catch (error) {
            setCurrEmailStatus(emailStatus?.email_sub || false);
        }

        setEmailSubChange(false);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (currEmailStatus === true) {
            updateEmailNotifications("sub");
        } else {
            updateEmailNotifications("unsub");
        }
    };

    return (
        <form onSubmit={handleSubmit}>
            <div className="rounded-lg overflow-hidden">
                <div className="bg-gray-50 dark:bg-brand-dark-700 px-4 py-3 border-b border-gray-200 dark:border-brand-dark-600">
                    <h3 className="text-lg font-medium text-gray-900 dark:text-white">
                        Notifications
                    </h3>
                </div>
                <div className="bg-white dark:bg-brand-dark-800 px-4 py-5 space-y-4">
                    <div className="flex items-center justify-between">
                        <span className="text-sm text-gray-700 dark:text-gray-300">Email Notifications</span>
                        <Switch
                            checked={currEmailStatus}
                            onChange={setCurrEmailStatus}
                            className={`${
                                currEmailStatus ? 'bg-brand-red-500' : 'bg-gray-200 dark:bg-gray-700'
                            } relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none`}
                        >
                            <span
                                className={`${
                                    currEmailStatus ? 'translate-x-6' : 'translate-x-1'
                                } inline-block h-4 w-4 transform rounded-full bg-white transition-transform`}
                            />
                        </Switch>
                    </div>
                    
                    {isEmailStatusError && (
                        <p className="text-sm text-brand-red-500 dark:text-brand-red-400">
                            {isEmailStatusError}
                        </p>
                    )}
                    
                    {isSubscribeError && (
                        <p className="text-sm text-brand-red-500 dark:text-brand-red-400">
                            {isSubscribeError}
                        </p>
                    )}
                    
                    {isUnsubscribeError && (
                        <p className="text-sm text-brand-red-500 dark:text-brand-red-400">
                            {isUnsubscribeError}
                        </p>
                    )}
                    
                    {emailSubChange && (
                        <div className="flex space-x-3 pt-3">
                            <SecondaryBtn
                                text="Cancel"
                                onClick={handleCancel}
                            />
                            <PrimaryBtn
                                text="Save Changes"
                                type="submit"
                            />
                        </div>
                    )}
                </div>
            </div>
        </form>
    );
};

export default Notifications;